import Audit from './Audit/Routes';
import Budgets from './Budgets/Routes';
import PreSanction from './PreSanction/Routes';
import NoteSheet from './NoteSheet/Routes';
import Inventory from './Inventory/Routes';
import FinalBill from './FinalBill/Routes';
import All from './Routes';

export default [...Budgets, ...All, ...Audit, ...PreSanction, ...NoteSheet, ...Inventory, ...FinalBill];